// One device row in the "Your protected device" list (presentational).
import styles from "../Connect.module.css";
import { DesktopIcon, MobileIcon } from "./ConnectIcons";

export default function DeviceCard({
  device,
  onOpenInApp,
  openInAppLabel = "OPEN IN APP",
  openInAppDisabled = false,
}) {
  const {
    name, kind, thisDevice, description,
    lastSeen, platform, appStatus, statusLabel, version, tunnelState,
  } = device;

  const pillOn = statusLabel === "APP OPENED";

  return (
    <div className={styles.deviceCard}>
      <div className={styles.deviceTop}>
        <div className={styles.deviceIcon}>
          {kind === "mobile" ? <MobileIcon size={20} /> : <DesktopIcon size={20} />}
        </div>

        <div className={styles.deviceIdentity}>
          <div className={styles.deviceNameRow}>
            <span className={styles.deviceName}>{name}</span>
            {thisDevice && <span className={styles.thisDeviceTag}>THIS DEVICE</span>}
            {version && <span className={styles.thisDeviceTag}>v{version}</span>}
          </div>
          <p className={styles.deviceDesc}>{description}</p>
        </div>

        <span className={`${styles.devicePill} ${pillOn ? "" : styles.devicePillWarn}`}>
          <span className={styles.pillDot} />
          {statusLabel}
        </span>
      </div>

      <div className={styles.deviceMeta}>
        <div className={styles.metaCell}>
          <span className={styles.metaLabel}>LAST SEEN</span>
          <span className={styles.metaValue}>{lastSeen}</span>
        </div>
        <div className={styles.metaCell}>
          <span className={styles.metaLabel}>PLATFORM</span>
          <span className={styles.metaValue}>{platform}</span>
        </div>
        <div className={styles.metaCell}>
          <span className={styles.metaLabel}>{tunnelState ? "TUNNEL" : "APP STATUS"}</span>
          <span className={styles.metaValue}>
            {tunnelState ? `${appStatus} · ${tunnelState}` : appStatus}
          </span>
        </div>

        {onOpenInApp && (
          <button
            type="button"
            className={`${styles.btn} ${styles.btnPrimary} ${styles.openInAppBtn}`}
            onClick={onOpenInApp}
            disabled={openInAppDisabled}
          >
            {openInAppLabel}
          </button>
        )}
      </div>
    </div>
  );
}
